export default __webpack_public_path__ + "static/media/Ballroll_00263.72619d17.png";